import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import store from './store'

import Home2 from './components/Home2.vue'
import Report from './components/Report.vue'
import Survey from './components/Survey.vue'
import Download from './components/Download.vue'
import { queryParser } from "./model/query-parser.js";

Vue.config.productionTip = false;

const routes = [
  { path: '/', component: Home2, name: 'home2', props: true },
  { path: '/survey', component: Survey, name: 'survey', props: true },
  { path: '/report', component: Report, name: 'report', props: true },
  { path: '/download', component: Download, name: 'download', props: true }
];

const router = new VueRouter({
  routes: routes,// short for `routes: routes`
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
});

Vue.use(VueRouter);

new Vue({
  router,
  //vuetify,
  store,
  render: h => h(App),
  mounted: function () {
    // console.log('mounted')
    // console.log('query:')
    // console.log(this.$route.query)

    let queryData = queryParser.parseQuery(this.$route.query)
    // console.log('queryData:')
    // console.log(queryData)
    // test queryData's valid existence by checking whether version is truthy 
    if (queryData.version) {
      this.$store.commit('applyQueryData', { queryData: queryData, override: false })
    }
  }
}).$mount('#app')
